import React from "react";
import { Player } from 'video-react';

const VideoPlayer = ({src}) => {
    return <Player fluid={false} width="100%">
        <source src={src}/>
    </Player>;
};

export default VideoPlayer;